// export const path = `https://localhost/alpha/`
// export const src = `php/`;
// export const path = `http://localhost/alpha-lh/`
//  export const src  =  "static/server/";
//export const path = `https://rapidtech.org.in/rapidtech/`
//export const src  =  "static/server/";

 export const path = `https://alphascans.in/alphascans/`;
export const src =   "static/server/";

// export const path = `https://rapidtech.org.in/alpha/`;
//  export const src =   "static/server/";
